import { useState, useCallback } from 'react';

interface UseDeleteConfirmationResult {
  isDeleteModalOpen: boolean;
  itemIdToDelete: number | null;
  selectedItems: number[];
  openDeleteModal: (id?: number) => void;
  closeDeleteModal: () => void;
  handleMultipleDelete: () => void;
  setSelectedItems: (items: number[]) => void;
  handleConfirmDelete: () => void;
}

export const useDeleteConfirmation = (
  onConfirmDelete: (id?: number) => void
): UseDeleteConfirmationResult => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState<number | null>(null);
  const [selectedItems, setSelectedItems] = useState<number[]>([]);

  const openDeleteModal = useCallback((id?: number) => {
    if (id) {
      setItemIdToDelete(id);
    } else {
      setItemIdToDelete(null);
    }
    setIsDeleteModalOpen(true);
  }, []);

  const closeDeleteModal = useCallback(() => {
    setIsDeleteModalOpen(false);
    setItemIdToDelete(null);
  }, []);

  const handleMultipleDelete = useCallback(() => {
    setItemIdToDelete(null);
    setIsDeleteModalOpen(true);
  }, []);

  const handleConfirmDelete = useCallback(() => {
    onConfirmDelete(itemIdToDelete || undefined);
    closeDeleteModal();
  }, [itemIdToDelete, onConfirmDelete, closeDeleteModal]);

  return {
    isDeleteModalOpen,
    itemIdToDelete,
    selectedItems,
    openDeleteModal,
    closeDeleteModal,
    handleMultipleDelete,
    setSelectedItems,
    handleConfirmDelete,
  };
};
